var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "lds-palette-ring",
    width: "80px",
    height: "80px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(150 50 50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 50 A30 30 0 0 1 59.270509831248425 78.53169548885461",
    fill: "none",
    stroke: "#ffffcb",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.270509831248425 78.53169548885461 A30 30 0 0 1 25.72949016875158 67.6335575687742",
    fill: "none",
    stroke: "#fac090",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.72949016875158 67.6335575687742 A30 30 0 0 1 25.729490168751575 32.366442431225806",
    fill: "none",
    stroke: "#ff7c81",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.729490168751575 32.366442431225806 A30 30 0 0 1 59.27050983124842 21.46830451114539",
    fill: "none",
    stroke: "#c0f6d2",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.27050983124842 21.46830451114539 A30 30 0 0 1 80 49.99999999999999",
    fill: "none",
    stroke: "#dae4bf",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 50 50;360 50 50",
    times: "0;1",
    dur: 1,
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading2);
export default __webpack_public_path__ + "static/media/loading2.4046923ee0d8dbea9550166a05b489e4.svg";
export { ForwardRef as ReactComponent };